export const messages = {
    main: {
        bullet: "●",
        pretitle: "Desarrollando emprendimientos",
        title: "Charlas abiertas de Eureka",
        clip1: "Desarrollando emprendimientos con Daniel Serrot",
        clip2: "Webinar con Mariela Karp",
    },
}